import $api from '../../http'

export const humanizeQuery = async (text: string, isEnhancedModel: boolean) => {
    try {
        const res = await $api.api.textsControllerMakeUnique({ 
            text,
            isRehumanize: false,
            isEnhancedModel
        })
        return res.data.data?.responses[0].text
    } catch (error) {
        console.log(error)
    }
}


export const rehumanizeQuery = async (text: string, isEnhancedModel: boolean) => {
    try {
        const res = await $api.api.textsControllerMakeUnique({ 
            text, 
            isRehumanize: true,
            isEnhancedModel
        })
        return res.data.data?.responses[0].text
    } catch (error) {
        console.error("Error in rehumanizeQuery:", error);
        throw error; // Re-throw the error
    }
}

export interface DetectAiQueryParams {
    text: string | undefined;
    isPostRehumanizationCheck?: boolean;
}

export const detectAiQuery = async (params: DetectAiQueryParams) => {
    try {
        if (!params.text) {
            console.warn("detectAiQuery called with no text");
            return; // Or throw new Error("Text is required for AI detection");
        }
        const res =
            await $api.api.textsPublicControllerGetUniquenessPercentages({
                text: params.text,
                isPostRehumanizationCheck: params.isPostRehumanizationCheck, // Pass the flag
            })
        return res.data.data?.responses
    } catch (error) {
        console.error("Error in detectAiQuery:", error);
        throw error; // Re-throw the error
    }
}
